import { Icon } from "@iconify/react/dist/iconify.js";

const EmptyData = ({ title = "داده ای برای نمایش یافت نشد" }) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="col-12 col-sm-8 col-md-6 col-lg-4">
        <div className="text-center bg-secondary-50 py-1 mt-1 radius-10 text-black">
          <Icon icon="nrk:media-404-notfound" className="display-1" />
          <p className="mt-3 fw-bold">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyData;
